import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import { CycleUtils } from '../utils';
import { BI_CYCLE_MAP } from './bi-consts';
export const getBiCycle = cycle => {
  if (!cycle) {
    return;
  }
  const cycleId = CycleUtils.convertCycleToCycleId(cycle);
  if (cycleId in BI_CYCLE_MAP) {
    return BI_CYCLE_MAP[cycleId];
  }
  return;
};
export const getBiChangePlanType = status => {
  if (status === 'currentProductInOffering') {
    return 'product_full_match';
  }
  if (status === 'currentProductFamilyInOffering') {
    return 'product_partial_match';
  }
  if (status === 'currentProductIsNotInOffering') {
    return 'product_not_match';
  }
  return undefined;
};
export const getBiOfferingType = saleType => {
  if (saleType === PurchaseOffering.SaleType.PERSONAL_SALE) {
    return 'Personal';
  }
  if (saleType === PurchaseOffering.SaleType.SEASONAL_SALE) {
    return 'Seasonal';
  }
  return 'Default';
};
//# sourceMappingURL=bi-utils.js.map